import { ClientType } from '../apollo'
import { types } from '../types'

import { deleteOneJobReview } from '@dinosband/bv-main-schema/dist/client-gql'

export async function deleteJobReview (client: ClientType, id: number): Promise<types.JobReview | undefined> {
  try {
    const result = await client.mutate({
      mutation: deleteOneJobReview,
      variables: {
        where: { id },
      },
    })
    return result.data.deleteOneJobReview
  } catch (e) {
  }
}
